<template>
  <div id="app" :class="theme">
    <Header />
    <router-view />
  </div>
</template>

<script>
import Header from './components/Header.vue';

export default {
  components: {
    Header,
  },
  computed: {
    theme() {
      return this.$store.state.theme;
    },
  },

};
</script>

<style>
body {
  margin: 0;
  font-family: 'Roboto', sans-serif;
  background-color: #f0f8ff;
  color: #2c3e50;
}
#app {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}
.light {
  background-color: #f0f8ff;
  color: #2c3e50;
}
.dark {
  background-color: #2c3e50;
  color: #ecf0f1;
}
</style>